class WimmelbuchConfigButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.boldText = this.querySelector('b');
    this.dialog = document.querySelector('wimmelbuch-config-dialog');
    this.button.addEventListener('click', this.handleClicked.bind(this));

    if (!this.dialog.completed) {
      this.button.classList.remove('button--tertiary');
      this.button.classList.add('button--primary');
    }

  }

  setCompleted() {
    this.boldText.innerHTML = this.dataset.customizePersonalisation; //'Personalisierung anpassen';
    this.button.classList.remove('button--primary');
    this.button.classList.add('button--tertiary');

  }

  handleClicked(e) {
    e.preventDefault();
    this.dialog.toggleDialog();
  }
}

customElements.define('wimmelbuch-config-button', WimmelbuchConfigButton);

class WimmelbuchConfigInputBreed extends HTMLElement {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.autoCompleteContainer = this.querySelector('.product-wimmelbuch__config--input-breed__autocomplete-container');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('blur', this.hideAutocomplete.bind(this));
    this.inputElement.addEventListener('focus', this.showAutocomplete.bind(this));

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

  handleInputChange() {
    this.autoCompleteContainer.innerHTML = '';
    const filteredData = this.inputElement.value == '' ? window.wimmelBuchConfig : window.wimmelBuchConfig.filter(item => item.animal.toLowerCase().includes(this.inputElement.value.toLowerCase()));
    this.handleNameInput();
    for (const item of filteredData) {
      const option = document.createElement('div');
      option.className = 'product-wimmelbuch__config--input-breed__autocomplete-option';
      const img = document.createElement('img');
      img.src = item.icon;
      img.alt = `${item.animal}`;
      img.className = "product-wimmelbuch__config--input-breed__autocomplete-option-icon";

      option.appendChild(img);
      option.appendChild(document.createTextNode(`${item.animal}`));
      option.dataset.id = item.name;

      option.addEventListener('click', () => {
        this.inputElement.value = item.animal;
        this.autoCompleteContainer.innerHTML = '';
        this.handleNameInput();
      });

      this.autoCompleteContainer.appendChild(option);
    }
  }

  handleNameInput() {
    const exists = window.wimmelBuchConfig.some(item => item.animal.toLowerCase().trim() == this.inputElement.value.toLowerCase().trim())
    if (!exists) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

  showAutocomplete() {
    this.autoCompleteContainer.style.display = 'block';
  }

  hideAutocomplete() {
    setTimeout(() => {
      this.autoCompleteContainer.style.display = 'none';
    }, 200);
  }
}

customElements.define('wimmelbuch-config-input-breed', WimmelbuchConfigInputBreed);

class WimmelbuchConfigDialog extends HTMLElement {
  constructor() {
    super();
    this.showDialog = false;
    this.step = 1;
    this.completed = false;
    this.breedInput = this.querySelector('#product-wimmelbuch__config--dialog__input-breed');
    this.nameInput = this.querySelector('#product-wimmelbuch__config--dialog__input-name');
    this.buttonNext = this.querySelector('.product-wimmelbuch__config--dialog__button__next');
    this.buttonBack = this.querySelector('.product-wimmelbuch__config--dialog__button__back');
    this.dialogStep1 = this.querySelector('#product-wimmelbuch__config--dialog__step-1');
    this.dialogStep2 = this.querySelector('#product-wimmelbuch__config--dialog__step-2');
    this.selectElement = this.querySelector("wimmelbuch-config-select-element");
    this.dialogStep3 = this.querySelector('#product-wimmelbuch__config--dialog__step-3');
    this.stepTextp = this.querySelector('.product-wimmelbuch__config--dialog__heading-step-text');
    this.dialogStep3.style.display = 'none';
    this.dialogStep2.style.display = 'none';

    this.selectedColor = null;
    this.inputCounter = this.querySelector("#product-wimmelbuch__input-counter");


    this.buttonNext.addEventListener('click', this.nextStep.bind(this));
    this.buttonBack.addEventListener('click', this.previousStep.bind(this));
    this.selectElement.addEventListener('change', (e) => {
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });

    this.nameInput.addEventListener('input', this.handleNameInput.bind(this));
  }

  handleNameInput() {
    if (this.nameInput.value == '' || this.nameInput.value.length <= 1) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  saveOrder() {
    const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
    const color = config.colors[parseInt(this.selectedColor)];

    const order = {
      breed: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('wimmelbuch-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelector(".product__media-list li").dataset.mediaId)
  }

  nextStep() {
    if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.innerHTML = this.dataset.configureBtn;
      this.buttonNext.disabled = true;

      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      this.handleNameInput();
    } else if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.selectedColor = null;
      const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
      document.querySelector('wimmelbuch-config-select-element').setElements(config.colors, this.selectedColor);
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }


    } else if (this.step == 3) {
      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.handleNameInput();
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
      if (!this.breedInput.value) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 3) {
      this.completed = false;

      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }

      this.buttonNext.innerHTML = this.dataset.nextBtn;

      this.dialogStep2.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
    this.querySelector('.product-wimmelbuch__config--dialog').style.display = this.showDialog ? 'flex' : 'none';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_toggle',
      'open': this.showDialog
    })
  }
}

customElements.define('wimmelbuch-config-dialog', WimmelbuchConfigDialog);


class WimmelbuchTab extends HTMLElement {
  constructor() {
    super();
    this.tab = this.querySelector('.product-wimmelbuch__collapsible--header');
    this.tab.addEventListener('click', this.handleTabClick.bind(this));
  }

  handleTabClick() {
    const tabContent = this.querySelector('.product-wimmelbuch__collapsible--header');
    tabContent.classList.toggle('active');
  }
}

customElements.define('wimmelbuch-tab', WimmelbuchTab);


class WimmelbuchMediaGallery extends HTMLElement {
  constructor() {
    super();

  }

  _enalbeLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'block';
  }

  _disableLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'none';
  }

  changeImage(order, color) {
    this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.innerHTML = `${order.name}?`);
    const diff = (order.name.length - 8);
    if (diff > 0) {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `${(36 - (diff * 2.25))}px`));
    } else {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `36px`));
    }
    const images = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    images[0]?.setAttribute('href', color.image_hc);
    images[1]?.setAttribute('href', color.image_sc);
  }
}

customElements.define('wimmelbuch-media-gallery', WimmelbuchMediaGallery);



class WimmelbuchConfigSelectElement extends HTMLElement {
  constructor() {
    super();
  }

  setElements(elements, selectedColor) {
    var html = '<div class="grid grid--2-col grid--3-col-tablet">';
    elements.forEach((elem, index) => {
      html += `<div class="grid__item"><input type="radio" name="color" value="${index}" ${(index == selectedColor) ? 'checked' : ''} id="color-${index}" /><label for="color-${index}"><img src="${elem.icon}" /></label></div>`;
    });
    html += '</div>'

    console.log(html);

    this.innerHTML = html;

  }
}

customElements.define('wimmelbuch-config-select-element', WimmelbuchConfigSelectElement);


class WimmelbuchStickAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyAtc = this.querySelector('#stickyATC');
    this.stickyATCButton = this.querySelector('#stickyATCButton');
    this.stickyATCButton.addEventListener('click', () => {
      document.querySelector('#wimmelbuchAtcButton').click();
    });
    window.addEventListener('scroll', (event) => {
      let mainBTN = document.querySelector(
        '.product__info-wrapper .product-wimmelbuch__config--button:not(.product-wimmelbuch__AddToCart_Sticky)'
      ) // document.getElementById("mainATC");

      if (this.isOutOfViewport(mainBTN).any) {
        this.stickyAtc.classList.add('sticky')
      } else {
        this.stickyAtc.classList.remove('sticky')
      }
    })

  }
  isOutOfViewport(elem) {
    // Get element's bounding
    var bounding = elem.getBoundingClientRect()

    // Check if it's out of the viewport on each side
    var out = {}
    out.top = bounding.top < 0
    out.left = bounding.left < 0
    out.bottom =
      bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight)
    out.right =
      bounding.right > (window.innerWidth || document.documentElement.clientWidth)
    out.any = out.top || out.left || out.bottom || out.right
    out.all = out.top && out.left && out.bottom && out.right

    return out
  }

  setCompleted() {
    this.querySelector(".product-wimmelbuch__config--button").style.display = "none";
    this.querySelector("#stickATCWrapper").style.display = "block";
  }
}

customElements.define('wimmelbuch-stick-atc', WimmelbuchStickAtc);
